// Layout condiviso delle pagine legali pubbliche (Privacy / Termini).
// Banner obbligatorio: contenuti DA REVISIONARE da parte legale prima del go-live.
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { Wordmark } from "@/components/landing/shared";
import { FooterLegal } from "@/components/public/FooterLegal";

export default function LegalLayout({ title, updatedAt, children, testId }) {
  return (
    <div className="min-h-screen bg-slate-50" data-testid={testId}>
      <header className="bg-[#0B192C] text-white">
        <div className="max-w-4xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center" data-testid="legal-home-link">
            <span className="inline-block bg-white rounded-lg px-3 py-1.5">
              <Wordmark compact />
            </span>
          </Link>
          <Link to="/login" className="text-sm text-white/80 hover:text-white"
            data-testid="legal-login-link">Accedi</Link>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-6 py-10">
        <div className="mb-8 rounded-lg border-2 border-amber-400 bg-amber-50 p-4 flex gap-3"
          role="alert" data-testid="legal-review-banner">
          <AlertTriangle className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" aria-hidden="true" />
          <p className="text-sm text-amber-900">
            <strong>DA REVISIONARE PRIMA DEL GO-LIVE.</strong> Questo documento è una
            bozza di lavoro: deve essere revisionato e approvato dal consulente legale
            prima del rilascio in produzione. Non costituisce consulenza legale.
          </p>
        </div>
        <h1 className="text-3xl font-bold text-slate-900 mb-1">{title}</h1>
        <p className="text-xs text-slate-500 mb-8">Ultimo aggiornamento: {updatedAt}</p>
        <div className="prose prose-slate max-w-none text-sm leading-relaxed space-y-6">
          {children}
        </div>
      </main>
      <footer style={{ background: "#0C2540" }} data-testid="legal-footer">
        <div className="max-w-4xl mx-auto px-6 pb-8"><FooterLegal /></div>
      </footer>
    </div>
  );
}
